interface HtmlIconProps {
  fill: string;
}

export default function HtmlIcon({ fill }: HtmlIconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_742_439)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.7441 4.41058C13.0695 4.08514 13.5972 4.08514 13.9226 4.41058L18.9226 9.41058C19.248 9.73602 19.248 10.2637 18.9226 10.5891L13.9226 15.5891C13.5972 15.9145 13.0695 15.9145 12.7441 15.5891C12.4186 15.2637 12.4186 14.736 12.7441 14.4106L17.1548 9.99984L12.7441 5.58909C12.4186 5.26366 12.4186 4.73602 12.7441 4.41058Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.25608 4.41058C7.58152 4.73602 7.58152 5.26366 7.25608 5.58909L2.84534 9.99984L7.25608 14.4106C7.58152 14.736 7.58152 15.2637 7.25608 15.5891C6.93065 15.9145 6.40301 15.9145 6.07757 15.5891L1.07757 10.5891C0.752137 10.2637 0.752137 9.73602 1.07757 9.41058L6.07757 4.41058C6.40301 4.08514 6.93065 4.08514 7.25608 4.41058Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_742_439">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
